var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { parseAsync as parse } from '../../parsing/parse';
import { legacyFilterUrls } from './MigrateLegacyData';
export var migrateFilterStore = function (state, version) { return __awaiter(void 0, void 0, void 0, function () {
    var updated;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                updated = __assign({}, state);
                if (version < 2) {
                    toV2(updated);
                }
                if (!(version < 3)) return [3 /*break*/, 2];
                return [4 /*yield*/, toV3(updated)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                if (!(version < 4)) return [3 /*break*/, 4];
                return [4 /*yield*/, toV4(updated)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/, updated];
        }
    });
}); };
/**
 * Corrects the missing source url in filters in the store, copies the source url from the legacy data
 */
var toV2 = function (state) {
    var _a;
    var data = JSON.parse((_a = localStorage.getItem('modular-filter-storage')) !== null && _a !== void 0 ? _a : '{}');
    var filters = Object.values(data.state.importedModularFilters);
    filters.forEach(function (_a) {
        var id = _a.id, _b = _a.source, owner = _b.owner, repo = _b.repo;
        var url = legacyFilterUrls["".concat(owner, ":").concat(repo)];
        if (!url) {
            return;
        }
        state.filters[id] = __assign(__assign({}, state.filters[id]), { source: url });
    });
};
/**
 * We moved back to having the rs2f stored on each module (though the whole thing also remains on the filter)
 */
var toV3 = function (state) { return __awaiter(void 0, void 0, void 0, function () {
    var updatedFilters;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all(Object.values(state.filters).map(function (filter) { return __awaiter(void 0, void 0, void 0, function () {
                    var parsed, updatedFilter;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, parse(filter.rs2f, true)];
                            case 1:
                                parsed = _a.sent();
                                if (parsed.errors) {
                                    console.error(parsed.errors);
                                    throw Error('Error parsing filter during migration');
                                }
                                updatedFilter = __assign({}, parsed.filter);
                                // Preserve certain fields off the original
                                // Ensures configurations still map correctly
                                updatedFilter.id = filter.id;
                                // User can edit these
                                updatedFilter.active = filter.active;
                                updatedFilter.name = filter.name;
                                updatedFilter.description = filter.description;
                                // We parsed from raw text- no url; so copy over source & date
                                updatedFilter.source = filter.source;
                                updatedFilter.importedOn = filter.importedOn;
                                // preserve original hash so that we don't immediately re-check for an
                                //  update for a filter that doesn't start with a module declaration.
                                updatedFilter.rs2fHash = filter.rs2fHash;
                                return [2 /*return*/, updatedFilter];
                        }
                    });
                }); }))];
            case 1:
                updatedFilters = _a.sent();
                state.filters = Object.fromEntries(updatedFilters.map(function (filter) { return [filter.id, filter]; }));
                return [2 /*return*/];
        }
    });
}); };
var toV4 = function (state) { return __awaiter(void 0, void 0, void 0, function () {
    var updatedFilters;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all(Object.values(state.filters).map(function (filter) { return __awaiter(void 0, void 0, void 0, function () {
                    var parsed, updatedFilter;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, parse(filter.rs2f, true)];
                            case 1:
                                parsed = _a.sent();
                                if (parsed.errors) {
                                    console.error(parsed.errors);
                                    throw Error('Error parsing filter during migration');
                                }
                                updatedFilter = __assign({}, parsed.filter);
                                // Preserve certain fields off the original
                                // Ensures configurations still map correctly
                                updatedFilter.id = filter.id;
                                // User can edit these
                                updatedFilter.active = filter.active;
                                updatedFilter.name = filter.name;
                                updatedFilter.description = filter.description;
                                // We parsed from raw text- no url; so copy over source & date
                                updatedFilter.source = filter.source;
                                updatedFilter.importedOn = filter.importedOn;
                                // preserve original hash so that we don't immediately re-check for an
                                //  update for a filter that doesn't start with a module declaration.
                                updatedFilter.rs2fHash = filter.rs2fHash;
                                return [2 /*return*/, updatedFilter];
                        }
                    });
                }); }))];
            case 1:
                updatedFilters = _a.sent();
                state.filters = Object.fromEntries(updatedFilters.map(function (filter) { return [filter.id, filter]; }));
                return [2 /*return*/];
        }
    });
}); };
